<template>
  <div class="headFixed freshStatus">
    <HeadNav title="系统状态"></HeadNav>
    <router-link :to="'/equipment'">
      <p class="freshHome">主页</p>
    </router-link>
    <!-- 会员 -->
    <div v-if="vip">
      <div v-if="pageNum===1">
        <p class="freshTitle">主板用户参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>工作模式
                <span class="right">
			      <span class="black">{{ eqInfo && eqInfo.airVentilator.workingMode1 === '0' ? "制冷" : "制热" }}</span>
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>用户状态
                <span class="right">
			      <span class="black">{{ "在家" }}</span>
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>热泵制冷设定
                <span class="right">
			      <span class="black">{{
                eqInfo && eqInfo.airVentilator.heatPumpCoolingTemperatureSetting ? eqInfo.airVentilator.heatPumpCoolingTemperatureSetting : 0
              }}</span>℃
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>热泵制热设定
                <span class="right">
			      <span class="black">{{
                eqInfo && eqInfo.airVentilator.heatPumpHeatingTemperatureSetting ? eqInfo.airVentilator.heatPumpHeatingTemperatureSetting : 0
              }}</span>℃
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>在家制冷温度设定
                <span class="right">
			      <span
                class="black">{{
                eqInfo && eqInfo.airVentilator.homeCoolingTemperatureSetting ? eqInfo.airVentilator.homeCoolingTemperatureSetting : 0
              }}</span>℃
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>在家制热温度设定
                <span class="right">
			      <span
                class="black">{{
                eqInfo && eqInfo.airVentilator.homeHeatingTemperatureSetting ? eqInfo.airVentilator.homeHeatingTemperatureSetting : 0
              }}</span>℃
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>在家制冷湿度设置
                <span class="right">
			      <span
                class="black">{{
                eqInfo && eqInfo.airVentilator.homeCoolingHumiditySetting ? eqInfo.airVentilator.homeCoolingHumiditySetting : 0
              }}</span>%
			    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>在家制热湿度设置
                <span class="right">
			      <span
                class="black">{{
                eqInfo && eqInfo.airVentilator.homeHeatingHumiditySetting ? eqInfo.airVentilator.homeHeatingHumiditySetting : 0
              }}</span>%
			    </span>
              </p>
            </div>
          </div>
        </div>
      </div>


      <div v-if="pageNum==2">
        <p class="freshTitle">主板状态参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>
                系统状态
                <span class="right">
		  				<span class="black">
		  					{{
                  eqInfo && eqInfo.airVentilator.systemStatus1
                      ? eqInfo.airVentilator.systemStatus1 === '0'
                          ? '正常关机'
                          : eqInfo.airVentilator.systemStatus1 === '1'
                              ? '远程关机'
                              : eqInfo.airVentilator.systemStatus1 === '2'
                                  ? '故障关机'
                                  : eqInfo.airVentilator.systemStatus1 === '3'
                                      ? '定时关机'
                                      : eqInfo.airVentilator.systemStatus1 === '4'
                                          ? '正常开机'
                                          : eqInfo.airVentilator.systemStatus1 === '5'
                                              ? '定时开机'
                                              : eqInfo.airVentilator.systemStatus1 === '6'
                                                  ? '机组防冻'
                                                  : eqInfo.airVentilator.systemStatus1 === '7'
                                                      ? '预热开机'
                                                      : eqInfo.airVentilator.systemStatus1 === '8'
                                                          ? '预热关机'
                                                          : eqInfo.airVentilator.systemStatus1 === '9'
                                                              ? '正在关机'
                                                              : '待机'
                      : '待机'
                }}
		  				</span>
		  			</span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>回风温度
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.returnAirTemperature ? eqInfo.airVentilator.returnAirTemperature : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>回风湿度
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.returnAirHumidity ? eqInfo.airVentilator.returnAirHumidity : 0
              }}</span>%
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>出风温度
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.airOutletTemperature ? eqInfo.airVentilator.airOutletTemperature : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>露点温度
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.dewPointTemperature ? eqInfo.airVentilator.dewPointTemperature : 0
            }}</span>℃
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器温度
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.humidifierTemperature ? eqInfo.airVentilator.humidifierTemperature : 0
            }}</span>℃
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>送风微压
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.airSupplyMicroPressure1 ? eqInfo.airVentilator.airSupplyMicroPressure1 : 0
            }}</span>kpa
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>新风微压
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.freshAirMicroPressure1 ? eqInfo.airVentilator.freshAirMicroPressure1 : 0
            }}</span>kpa
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>顶棚一次出水
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.radiatorPrimaryOutlet ? eqInfo.airVentilator.radiatorPrimaryOutlet : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>顶棚二次进水
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.radiatorSecondaryInlet ? eqInfo.airVentilator.radiatorSecondaryInlet : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>顶棚二次出水
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.radiatorSecondaryOutlet ? eqInfo.airVentilator.radiatorSecondaryOutlet : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>表冷器进水
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.coilInlet ? eqInfo.airVentilator.coilInlet : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>表冷器出水
                <span class="right">
	          <span class="black">{{
                eqInfo && eqInfo.airVentilator.coilOutlet ? eqInfo.airVentilator.coilOutlet : 0
              }}</span>℃
	        </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>排风机
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.exhaustFan1 ? (eqInfo.airVentilator.exhaustFan1) : 0
            }}</span>v
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>新风机
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.freshAirFan1 ? (eqInfo.airVentilator.freshAirFan1) : 0
            }}</span>v
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>送风机
                <span class="right">
		      <span class="black">{{ eqInfo && eqInfo.airVentilator.fan1 ? (eqInfo.airVentilator.fan1) : 0 }}</span>v
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>表冷器三通阀
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.threeWayValveCoil1 ? eqInfo.airVentilator.threeWayValveCoil1 : 0
            }}</span>v
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>辐射三通阀
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.threeWayValveRadiator1 ? eqInfo.airVentilator.threeWayValveRadiator1 : 0
            }}</span>v
		    </span>
              </p>
            </div>
          </div>
          <!-- <div class="item" v-if="guzhang!=null">
            <div class="clear">
                <router-link :to="'/fault/'+this.getId()">
              <p>故障
                <span class="right">
                <span class="black">{{guzhang.length}}</span>
              </span>
              </p>
          </router-link>
            </div>
          </div> -->
        </div>
      </div>


      <div v-if="pageNum==3">
        <p class="freshTitle">主板输出参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>负氧离子
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.negativeIonGeneratorFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>顶棚辐射泵
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.ceilingRadiatorPumpFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>一次泵
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.primaryPumpFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器排水
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.humidifierDrainFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器补水
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.humidifierWaterSupplyFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器加湿
                <span class="right">
              <span class="black">{{ eqInfo && eqInfo.airVentilator.humidifierFailure1 === '1' ? '开' : '关' }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>精加热
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.precisionHeatingFailure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>排风机
                <span class="right">
		      <span class="black">{{ eqInfo && eqInfo.airVentilator.exhaustFanFailure1 === '1' ? '开' : '关' }}</span>
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>新风机
                <span class="right">
		      <span class="black">{{ eqInfo && eqInfo.airVentilator.freshAirFanFailure1 === '1' ? '开' : '关' }}</span>
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>除湿压缩机
                <span class="right">
              <span class="black">{{
                  eqInfo && eqInfo.airVentilator.dehumidifierCompressorY11Failure1 === '1' ? '开' : '关'
                }}</span>
            </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>多功能杀菌仪
                <span class="right">
		      <span class="black">{{
              eqInfo && eqInfo.airVentilator.multifunctionalSterilizerFailure1 === '1' ? '开' : '关'
            }}</span>
		    </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>送风机
                <span class="right">
		      <span class="black">{{ eqInfo && eqInfo.airVentilator.supplyFanFailure1 === '1' ? '开' : '关' }}</span>
		    </span>
              </p>
            </div>
          </div>
        </div>
      </div>


      <div v-if="pageNum==4">
        <p class="freshTitle">主板输入参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="item">
            <div class="clear">
              <p>水泵故障
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.waterPumpFailureX001 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>防冻开关1
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.antiFreezeSwitchX011 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>防冻开关2
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.antiFreezeSwitchX021 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>燃气报警
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.gasLeakAlarmX031 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>漏水报警
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.waterLeakAlarmX041 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>露点报警
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.dewPointAlarmX051 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器漏水
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.humidifierWaterLeakX061 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器过热
                <span class="right">
		        <span class="black">{{ eqInfo && eqInfo.airVentilator.humidifierOverheatX071 === '1' ? '开' : '关' }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器水位上限
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.humidifierWaterLevelUpperLimitX101 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>加湿器水位下限
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.humidifierWaterLevelLowerLimitX111 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>高效过滤
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.highEfficiencyFilterX121 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>初中效过滤
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.mediumEfficiencyFilterX131 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>送风风压差
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.airPressureDifferenceX141 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
          <div class="item">
            <div class="clear">
              <p>除湿压机故障
                <span class="right">
		        <span class="black">{{
                eqInfo && eqInfo.airVentilator.dehumidifierCompressorFailureX151 === '1' ? '开' : '关'
              }}</span>
		      </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="page">
        <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum>1">上一页</div>
        <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum<4">下一页</div>
      </div>
    </div>


    <div v-else>
      <div v-if="pageNum===1">
        <p class="freshTitle">主板输出参数</p>
        <div class="list list_normal list_no_arrow list_info">
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.negativeIonGeneratorFailure1 === '1' ?'on':'off'">
              负氧离子</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.ceilingRadiatorPumpFailure1 ==='1'?'on':'off'">
              顶棚辐射泵</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.primaryPumpFailure1==='1'?'on':'off'">一次泵</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.humidifierDrainFailure1 ==='1'?'on':'off'">
              加湿器排水</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.humidifierWaterSupplyFailure1==='1'?'on':'off'">
              加湿器补水</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.humidifierFailure1==='1'?'on':'off'">加湿器加湿</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.precisionHeatingFailure1==='1'?'on':'off'">精加热</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.exhaustFanFailure1==='1'?'on':'off'">排风机</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.freshAirFanFailure1==='1'?'on':'off'">新风机</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.dehumidifierCompressorY11Failure1==='1'?'on':'off'">
              除湿压缩机</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.multifunctionalSterilizerFailure1==='1'?'on':'off'">
              多功能杀菌仪</p>
          </div>
          <div class="list-item">
            <p :class="eqInfo&&eqInfo.airVentilator.supplyFanFailure1==='1'?'on':'off'">送风机</p>
          </div>
        </div>
      </div>

      <!--    <div class="page">
            <div class="btn-primary pagePrev" @click="goPrev()" v-if="pageNum>1">上一页</div>
            <div class="btn-orange pageNext" @click="goNext()" v-if="pageNum<2">下一页</div>
          </div> -->
    </div>

  </div>
</template>
<script>
import HeadNav from '../../headNav/headNav'
import { KJUR, b64utoutf8 } from 'jsrsasign';
export default {
  name: 'info',
  data() {
    return {
      vip: null,
      guzhang: null,
      eqInfo: null,
      socket: "",
      pageNum: 1
    }
  },
  components: {
    'HeadNav': HeadNav
  },
  mounted() {
    this.readWaterTemerature();
    this.firstRequest = true;
    // this.getFreshEquipmentDetail();
    // this.getFaultList();
    this.vips();
  },

  beforeDestroy() {
    // this.socketclose();
  },
  methods: {
    vips() {
      let token = localStorage.getItem('token');
      // 拆分JWT令牌
      const parts = token.split('.');

      // 获取JWT payload（部分1）
      const payload = parts[1];

      // 将base64编码的payload解码为UTF-8字符串
      const decodedPayload = b64utoutf8(payload);

      // 解析JSON格式的payload
      const parsedPayload = JSON.parse(decodedPayload);
      console.log(parsedPayload)
      this.vip = parsedPayload['vip'];
    },
    getFaultList() {
      let that = this;
      let arr = [];
      arr.push('equipmentId=' + this.$route.params.id);
      let str = arr.join('&');
      this.Api.faultList(str, function (msg) {
        if (msg.code == 200) {
          let data = msg.body.results;
          let item = [];
          for (var i = 0; i < data.length; i++) {
            let obj = {};
            let title = data[i].alarmDetail.substring(0, 3);
            if (title != '热泵1' && data[i].status != 2 && title != '热泵2') {
              obj.title = data[i].alarmDetail;
              obj.time = data[i].alarmTime;
              switch (data[i].type) {
                case 1:
                  obj.type = "degreeA";
                  break;
                case 2:
                  obj.type = "degreeB";
                  break;
                case 3:
                  obj.type = "degreeC";
                  break;
                default:
                  obj.type = "degreeA";
              }
              item.push(obj);
            }
          }
          if (item.length != 0) {
            that.guzhang = item;
          }
        }
      });
    },
    readWaterTemerature() {
      let str = 'id=' + this.getId();
      this.Api.eqDetail(this.getId(), (msg) => {
        if (msg.code === 200) {
          this.eqInfo = msg.data;
          //初始化websocket
          if (typeof (WebSocket) === "undefined") {
            alert("您的浏览器不支持socket")
          } else {
            // 实例化socket
            this.socket = this.$store.state.websocket
            if (!this.socket) {
              this.socket = new WebSocket(this.$websocketUrl + this.eqInfo.iotDeviceId);
            }
            // // 监听socket连接
            this.socket.onopen = this.socketopen
            // 监听socket错误信息
            this.socket.onerror = this.socketerror
            // 监听socket消息
            this.socket.onmessage = this.getMessage
            // 关闭socket消息
            this.socket.onclose = this.socketclose
            this.$store.commit('setWebSocket', this.socket);
          }
          this.firstRequest = false;
        }
      })
    },
    getId() {
      return this.$route.params.id;
    },
    socketopen: function () {
      console.log("socket连接成功")
    },
    socketerror: function () {
      console.log("连接错误")
    },
    getMessage: function (msg) {
      let data = JSON.parse(msg.data);
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          // 使用 Vue.$set 确保触发响应性更新
          this.$set(this.eqInfo.airVentilator, key, data[key]);
        }
      }
    },
    socketclose: function () {
      alert(111)
      console.log("socket已经关闭")
      this.$store.state.websocket = null
      this.socket.close()
    }
    ,
    // getFreshEquipmentDetail() {
    //     let id = this.getId();
    //     this.Api.freshEquipmentDetail('equipmentId=' + id, (msg) => {
    //         if (msg.body) {
    //             this.eqInfo = msg.body;
    //         }
    //     })
    // },
    goPrev() {
      let pageNum = this.pageNum;
      pageNum--;
      if (pageNum <= 1) {
        pageNum = 1
      }
      this.pageNum = pageNum;
    }
    ,
    goNext() {
      let pageNum = this.pageNum;
      pageNum++;
      this.pageNum = pageNum;
    }
  }
}
</script>
<style scoped>
@import url('../../../assets/list.css');
</style>





// WEBPACK FOOTER //
// src/components/freshAir/status/status4.vue